<template>
  <div style="height: 100%; width: 100%" class="flex">
    <div class="leftDiv flex">
      <div class="schoolRank">
        <div class="tableBody">
          <div
            v-for="(item, indexs) in list"
            :key="indexs"
            :style="{ height: item.src != '' ? '1.34rem' : '0.4rem' }"
            class="ysList"
            @click="videoClick(item, indexs)"
          >
            <div
              class="videoDiv flex"
              :class="item.src != '' ? 'videoNav' : 'wzNav'"
            >
              <div style="height: 85%; width: 90%" v-if="item.src != ''">
                <div class="topTitle">
                  <div class="xcTop flex">
                    <span style="margin-left: 13px">视频监控</span>
                  </div>
                  <div class="circle">
                    <div class="circle_x">
                      <div class="circle_zj num flex">
                        {{ indexs + 1 }}
                      </div>
                      <img src="~images/video/circle.png" class="arround" />
                    </div>
                  </div>
                </div>
                <div class="botTitle">
                  <img
                    src="@/assets/images/video/video-pic01.jpg"
                    style="width:calc(100% - 3px);height:calc(100% - 3px);border:1.5px solid #077EA3;"
                  />
                  <!-- v-lazy="item.src" -->
                  <!-- <div class="video-name">视频名称</div> -->
                </div>
              </div>
              <div
                class="sp_wz"
                :style="{
                  color: xzIndex == indexs ? '#fff' : '#ccc',
                }"
              >
                {{ item.name }}
              </div>
            </div>
            <div :class="xzIndex == indexs ? 'cover' : 'cover1'"></div>
          </div>
        </div>
        <!-- </vue-seamless-scroll> -->
      </div>
    </div>
    <div class="rightDiv">
      <div class="contMain">
        <!-- <div class="topRight flex">
          <div class="titleName">{{ name }}</div>
          <div class="titleLine">
            <img src="~images/video/title-line.png" />
          </div>
          <div class="titleImg flex" @click="djClick">
            <img src="~images/video/icon-fd.png" />
          </div>
        </div> -->
        <div class="botRight">
          <!-- <video-player
            v-if="version"
            
            class="video-player vjs-custom-skin videobox"
            ref="videoPlayer"
            :playsinline="true"
            :options="playerOptions"
            @ready="playerReadied"
          > 
          </video-player>-->
          <div class="video-box">
            <div
              class="video-item"
              v-for="(item, i) in rightList"
              :key="i"
              :class="{ bling: usedIndex === i }"
            >
              <video
                :id="'video' + i"
                v-if="item.used"
                style="width: 100%; height: 100%;"
                controls
                autoplay
              ></video>
              <!-- muted -->
              <div v-else class="center-text">暂无视频</div>
              <i
                v-if="item.used"
                class="el-icon-close"
                @click.stop="closeVideo(i)"
              ></i>
            </div>
          </div>

          <!-- <video
            id="video"
            v-if="version"
            style="width: 100%; height: 100%;"
            controls
            autoplay
          ></video>
          <img
            v-else
            src="img/play-btn.png"
            alt=""
            class="play-btn"
            @click="toPlay"
          /> -->

          <!-- <iframe
            v-else
            :src="
              './hk_video/video.html?ip=' +
                hkItem.ip_ +
                '&port=' +
                hkItem.port_ +
                '&token=' +
                hkItem.admintoken_ +
                '&width=100%&height=100%&controlshow=' +
                ycShow
            "
            style="width: 100%; height: 100%"
            frameborder="0"
          ></iframe> -->
          <!-- <div v-show="index == 2" class="spDiv flex">暂无视频</div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { videoPlayer } from "vue-video-player";
// import "video.js/dist/video-js.css";
// import "vue-video-player/src/custom-theme.css";
// import "videojs-contrib-hls";
import { get } from "@/api/index";
export default {
  //   components: {
  //     videoPlayer
  //   },

  data() {
    return {
      version: false,
      ycShow: "hide",
      hkItem: {
        ip_: "183.234.13.150",
        port_: "8000",
        admintoken_: "YWRtaW46bHpkc2owMDE=",
      },
      list: [],
      rightList: [
        {
          src: require("@/assets/images/video/video-pic01.jpg"),
          name: "",
          url: "",
          used: false, // 是否被占用
        },
        {
          src: require("@/assets/images/video/video-pic01.jpg"),
          name: "",
          url: "",
          used: false, // 是否被占用
        },
        {
          src: require("@/assets/images/video/video-pic01.jpg"),
          name: "",
          url: "",
          used: false, // 是否被占用
        },
        {
          src: require("@/assets/images/video/video-pic01.jpg"),
          name: "",
          url: "",
          used: false, // 是否被占用
        },
      ],
      name: "",
      xzIndex: 0,
      usedIndex: -1, // 当前高亮的视频，若已被插入到队列中，则表示已插入到队列中的下标
      videoUrl: "http://121.32.129.19:9928/",
      playerOptions: {
        playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
        autoplay: true, // 如果为true,浏览器准备好时开始回放。
        muted: true, // 默认情况下将会消除任何音频。
        loop: true, // 是否视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "application/x-mpegURL", // 类型
            src: "http://121.32.129.19:9928/stream/htzzc1017/index.m3u8", // url地址
          },
        ],
        poster: "", // 封面地址
        notSupportedMessage: "此视频暂无法播放，请稍后再试", // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, // 当前时间和持续时间的分隔符
          durationDisplay: true, // 显示持续时间
          remainingTimeDisplay: false, // 是否显示剩余时间功能
          fullscreenToggle: true, // 是否显示全屏按钮
        },
      },
      myPlayer: null,
      myPlayerArr: [],
      videoIndex: 0,
      seleIndex: 0,
    };
  },
  mounted() {
    this.resetList();
    this.getdata();
  },
  methods: {
    getdata() {
      get("/api/restful/getWlwVideoALL").then((res) => {
        this.list = res.data.map((e) => {
          if (process.env.NODE_ENV === "prod1") {
            e.url = e.url.replace(
              window.__config.spUrl,
              "https://" + location.host + "/mm/m-screen/zt/zlcy"
            );
            e.url = e.url.replace(
              window.__config.spUrl_1,
              "https://" + location.host + "/mm/m-screen/zt/zlcy"
            );
            e.url = e.url.replace(
              "http://hls01open.ys7.com",
              "https://" + location.host + "/mm/m-screen/zt/zlcy"
            );
          }
          if (e.pic) {
            // let arr = JSON.parse(e.pic.replace("/", "//"));
            let src = window.__config.VUE_APP_IMG_URL + e.pic;
            return {
              src: src,
              name: e.name,
              url: e.url,
            };
          } else {
            return {
              src: require("@/assets/images/video/video-pic01.jpg"),
              name: e.name,
              url: e.url,
            };
          }
        });
        this.name = this.list[0].name;
        this.videoUrl = "http://121.32.129.19:9928/";
        // this.playerOptions.sources[0].src = this.list[0].url;
        // this.playM3u8(this.list[0].url);
        if (this.list.length > 0) {
          this.videoClick(this.list[0], 0);
        }
      });
    },
    // xzIndex
    toPlay() {
      this.version = true;
      this.$nextTick(() => {
        this.playM3u8(this.list[this.xzIndex].url);
      });
    },
    // 播放单个
    playM3u8(url) {
      if (window.Hls.isSupported()) {
        this.video = document.getElementById("video");
        this.video.volume = 0.3;
        var hls = new window.Hls();
        var m3u8Url = decodeURIComponent(url);
        hls.loadSource(m3u8Url);
        hls.attachMedia(this.video);
        hls.on(window.Hls.Events.MANIFEST_PARSED, function() {
          this.video.play();
        });
      }
    },
    // 播放数组中的指定一个
    playListM3u8(url, index) {
      if (window.Hls.isSupported()) {
        const video = document.getElementById("video" + index);
        // console.log("muted", video.muted);
        // if (video.muted === true){
        //   video.muted = false; // 取消静音
        // }
        video.volume = 0.3; // 控制音量
        var hls = new window.Hls();
        var m3u8Url = decodeURIComponent(url);
        hls.loadSource(m3u8Url);
        hls.attachMedia(video);
        hls.on(window.Hls.Events.MANIFEST_PARSED, function() {
          video.play();
        });
      }
    },
    videoClick(item, indexs) {
      console.log("videoClick", item, indexs);
      this.xzIndex = indexs;
      // 查找是否已插入到队列中
      let index = -1;
      this.rightList.some((ele, i) => {
        if (ele.used) {
          if (ele.name === item.name && ele.url === item.url) {
            index = i;
            return true;
          }
        }
      });

      if (index === -1) {
        // 未插入到队列中
        let index2 = -1;
        this.rightList.some((ele, i) => {
          if (!ele.used) {
            index2 = i;
            return true;
          }
        });
        index2 = index2 > -1 ? index2 : this.rightList.length - 1;
        this.rightList[index2] = Object.assign({}, item, { used: true });
        const url = this.rightList[index2].url;
        // if (url) {
        this.$nextTick(() => {
          this.playListM3u8(url, index2);
        });
        // }
      } else {
        // 已插入到队列中
        this.usedIndex = index;
        setTimeout(() => {
          this.usedIndex = -1;
        }, 800);
      }

      console.log("rightList", this.rightList, this.usedIndex);

      // //   this.playerOptions.sources[0].src = item.url;
      // //   this.playerOptions.poster = item.src;
      // //   this.playM3u8(item.url);
      // this.version = false;
      // this.name = item.name;
      // if (this.videoIndex !== indexs) {
      //   this.myPlayerArr = [];
      //   this.videoIndex = indexs;
      // }
      // //   let key = setInterval(() => {
      // //     this.$refs['videoPlayer' + this.seleIndex][0].player.play()
      // //     clearInterval(key)
      // //   }, 500)
    },
    closeVideo(i) {
      if (this.rightList[i] && this.rightList[i].used) {
        const item = {
          src: require("@/assets/images/video/video-pic01.jpg"),
          name: "",
          url: "",
          used: false, // 是否被占用
        };
        this.$set(this.rightList, i, item); //触发更新视图
      }
      console.log("closeVideo", this.rightList);
    },
    djClick() {
      this.video.requestFullscreen();

      //   if (!this.myPlayerArr[this.seleIndex].isFullscreen()) {
      //     this.myPlayerArr[this.seleIndex].requestFullscreen();
      //     this.myPlayerArr[this.seleIndex].isFullscreen(true);
      //   } else {
      //     this.myPlayerArr[this.seleIndex].exitFullscreen();
      //     this.myPlayerArr[this.seleIndex].isFullscreen(false);
      //   }
    },
    playerReadied(e) {
      this.myPlayerArr.push(e);
    },
    prevs() {
      let xzIndex;
      if (this.xzIndex > 0) {
        xzIndex = this.xzIndex - 1;
      } else {
        xzIndex = this.list.length;
      }
      this.videoClick(this.list[xzIndex], xzIndex);
    },
    nexts() {
      let xzIndex;
      if (this.xzIndex < this.list.length) {
        xzIndex = this.xzIndex + 1;
      } else {
        xzIndex = 0;
      }
      this.videoClick(this.list[xzIndex], xzIndex);
    },
    resetList() {
      this.rightList = [
        {
          src: require("@/assets/images/video/video-pic01.jpg"),
          name: "",
          url: "",
          used: false, // 是否被占用
        },
        {
          src: require("@/assets/images/video/video-pic01.jpg"),
          name: "",
          url: "",
          used: false, // 是否被占用
        },
        {
          src: require("@/assets/images/video/video-pic01.jpg"),
          name: "",
          url: "",
          used: false, // 是否被占用
        },
        {
          src: require("@/assets/images/video/video-pic01.jpg"),
          name: "",
          url: "",
          used: false, // 是否被占用
        },
      ];
      this.xzIndex = 0;
      this.usedIndex = -1;
    },
  },
};
</script>

<style lang="stylus" scoped>
.flex
  display flex
  align-items center
.leftDiv
  width 20%
  margin-right 18px
  height 100%
  justify-content center
.rightDiv
  width calc(80% - 18px)
  height 100%
  background url('~images/video/bg-video.png') no-repeat center
  background-size 100% 100%
.tops
  position relative
  height calc(100% - 0px)
  width 98%
  margin 0 1%
  overflow hidden
  z-index 9
.imgcasesT
  width 100%
  position relative
  overflow initial
  margin 0
  height 100%
  z-index 990
  &::-webkit-scrollbar
    width 4px
    background-color #00162D
  /* 定义滚动条轨道 内阴影+圆角 */
  &::-webkit-scrollbar-track
    -webkit-box-shadow inset 0 0 6px transparent
    background-color transparent
  /* 定义滑块 内阴影+圆角 */
  &::-webkit-scrollbar-thumb
    border-radius 10px
    -webkit-box-shadow inset 0 0 6px transparent
    background-color $textColor
  /* 定义最上方和最下方的按钮 */
  &::-webkit-scrollbar-button
    height 0
.swiper-slides
  display flex
  align-content center
  justify-content center
  flex-direction column
  z-index 9
.swiper-button-next, .swiper-container-rtl .swiper-button-prev
  right 8px
  left auto
.swiper-button-prev, .swiper-container-rtl .swiper-button-next
  left 6px
  right auto
.swiper-button-prev
  background url('~images/video/left.png') center no-repeat
  background-size 100% 100%
.swiper-button-next
  background url('~images/video/right.png') center no-repeat
  background-size 100% 100%
.swiper-button-prev, .swiper-button-next
  position absolute
  top 49%
  width 40px
  height 53px
  margin-top -22px
  z-index 100
  cursor pointer
  background-position center
.schoolRank
  width 100%
  height 100%
  display flex
  justify-content center
.ysList
  width calc(100% - 5px)
  position relative
  margin-bottom 10px
  margin-right 5px
  cursor pointer
.ysList:last-child
  margin-bottom 0px
.tableBody
  height calc(100% - 30px)
  overflow auto
  width calc(100% - 25px)
  border 1px #0E274C solid
  padding 14px 10px 14px 15px
  &::-webkit-scrollbar
    width 4px
    background-color #030814
  /* 定义滚动条轨道 内阴影+圆角 */
  &::-webkit-scrollbar-track
    -webkit-box-shadow inset 0 0 6px transparent
    background-color transparent
  /* 定义滑块 内阴影+圆角 */
  &::-webkit-scrollbar-thumb
    border-radius 10px
    -webkit-box-shadow inset 0 0 6px transparent
    background-color #377DC0
  /* 定义最上方和最下方的按钮 */
  &::-webkit-scrollbar-button
    height 0
.sp_wz
  color #fff
  font-size 0.07rem
  width 100%
  justify-content center
  display flex
  align-items flex-end
.videobox
  height 100%
  width calc(100% - 0px)
  border-radius 10px
.contMain
  // height calc(100% - 20px)
  // width calc(100% - 40px)
  // margin 10px 20px
  height calc(100% - 40px)
  width calc(100% - 40px)
  margin 20px
.topRight
  width 100%
  height 7%
  color #fff
.botRight
  width 100%
  // height 93%
  height 100%
  color #fff
  position relative
.video-box
  width 100%
  height 100%
  border-top 1px solid #ddd
  border-left 1px solid #ddd
  box-sizing border-box
  overflow hidden
  .video-item
    float left
    width 50%
    height 50%
    position relative
    border-right 1px solid #ddd
    border-bottom 1px solid #ddd
    box-sizing border-box
    video
      border none
      height 100% !important
    .el-icon-close
      position absolute
      top 0
      right 0
      font-size 30px
      color red
      cursor pointer
.play-btn
  width 50px
  height 50px
  position absolute
  top 50%
  left 50%
  transform translate(-50%,-50%)
  cursor  pointer
.center-text
  position absolute
  top 50%
  left 50%
  transform translate(-50%,-50%)

.titleName
  font-size 0.12rem
  font-weight 500
  letter-spacing 2px
  background-image -webkit-linear-gradient(top, #EAF5FA, #0AA5F2)
  -webkit-background-clip text
  -webkit-text-fill-color transparent
.titleLine
  width 60%
.titleImg
  position absolute
  top 0.01rem
  right 0.1rem
  cursor pointer
  height 7%
.botNav
  position relative
  height 100%
  width 0.5rem
  font-size 0.08rem
  justify-content center
  cursor pointer
.lines
  width 100%
  height 2px
  background #3981E0
  position absolute
  top -2.5px
  left 0
.sjx
  position absolute
  top -13px
  left 0px
  width 100%
  height 15px
  justify-content center
.sjx img
  height 100%
.videoDiv
  width calc(100% - 40px)
  height calc(100% - 20px)
  padding 10px 20px
  justify-content center
  flex-wrap wrap
.cover
  width 100%
  height 100%
  position absolute
  top 0
  left 0
  background rgba(30, 30, 30, 0)
.cover1
  width 100%
  height 100%
  position absolute
  top 0
  left 0
  background rgba(30, 30, 30, 0.32)
.videoNav
  background url('~images/video/video_nav.png') no-repeat center
  background-size 100% 100%
.wzNav
  background url('~images/video/wz_nav.png') no-repeat center
  background-size 100% 100%
.topTitle
  height 25%
  width 100%
  display flex
  align-items flex-end
  justify-content flex-end
  position relative
.botTitle
  height 75%
  width 100%
  position relative
.video-name
  width 100%
  height 30px
  position absolute
  left 0
  bottom 0
  line-height 30px
  font-size 14px
  padding-left 10px
  box-sizing border-box
  color #fff
  background rgba(0,0,0,.6)
// 闪烁
.bling
  animation shanshuo .4s linear infinite
@keyframes shanshuo {
  0% {
      transform: scale(0.98);
      opacity: 0.3
  }
  50% {
      transform: scale(1);
      opacity: 0.7
  }
  100% {
      transform: scale(1.02);
      opacity: 1
  }
}
.xcTop
  background url('~images/video/title-right.png') no-repeat center
  background-size 100% 100%
  height 60%
  width 45%
  justify-content center
  letter-spacing 2px
  font-size 0.06rem
.circle
  position absolute
  bottom -0.1rem
  left -0.1rem
  width 0.3rem
  height 0.3rem
  background rgba(13, 35, 82, 1)
.circle_x
  position relative
  top 0.01rem
  width 0.2rem
  height 0.2rem
  left 22%
.arround
  position absolute
  width 0.2rem
  height 0.2rem
  top 25%
  left 0
  animation rotation 5s linear infinite
  -moz-animation rotation 5s linear infinite
  -webkit-animation rotation 5s linear infinite
  -o-animation rotation 5s linear infinite
@keyframes rotation
  from
    -webkit-transform rotate(0deg)
  to
    -webkit-transform rotate(360deg)
.circle_zj
  position absolute
  top 25%
  left 0
  width 100%
  height 100%
  justify-content center
.num
  font-size 0.12rem
.spDiv
  width 100%
  height 100%
  justify-content center
  font-size 0.2rem
  letter-spacing 5px
@media (max-width 1280px)
  .sp_wz
    font-size 0.08rem
  .xcTop
    width 55%
    font-size 0.08rem
  .videoDiv
    width calc(100% - 20px)
    height calc(100% - 17px)
    padding 8.5px 10px
</style>
<style>
.video-js.vjs-fluid,
.video-js.vjs-16-9,
.video-js.vjs-4-3 {
  height: 100% !important;
  padding-top: 0 !important;
  width: 100% !important;
}
.vjs-tech {
  width: 100% !important;
  height: 100% !important;
  object-fit: fill !important;
}
.vjs-custom-skin > .video-js .vjs-big-play-button {
  display: none;
}
.vjs-poster {
  background-position: center !important;
  background-size: cover !important;
}
.dddd {
  width: calc(100% - 2px) !important;
  height: calc(100% - 2px) !important;
  object-fit: fill;
  border: 1px #31d5f3 solid;
}
.videoboxs1 {
  height: 100%;
  width: calc(100% - 0px);
  border-radius: 10px;
}
video {
  width: calc(100% - 2px) !important;
  height: calc(100% - 2px) !important;
  border: 1px #31d5f3 solid;
}
.el-pagination {
  color: #fff !important;
}
.el-pagination__total {
  color: #fff !important;
}
.el-pagination__jump {
  color: #fff !important;
}
.el-dialog,
.el-pager li {
  background: #15264f !important;
}
.el-pagination button:disabled {
  color: #fff !important;
  background-color: #15264f !important;
}
.el-pagination .btn-next,
.el-pagination .btn-prev {
  background: #15264f !important;
  color: #fff !important;
}
.el-input__inner {
  background-color: #15264f !important;
  border: 1px solid #dcdfe6;
  color: #fff !important;
}
.el-pager li.active {
  color: #0ff !important;
}
.el-pager li:hover {
  color: #0ff !important;
}
</style>
